import React from 'react';

export const DownloadPdfIcon = ({ width = 25, height = 24, color = "black", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                className={className}
                d="M18.5 18V21H6.5V18H5V21C5 21.3978 5.15804 21.7794 5.43934 22.0607C5.72064 22.342 6.10218 22.5 6.5 22.5H18.5C18.8978 22.5 19.2794 22.342 19.5607 22.0607C19.842 21.7794 20 21.3978 20 21V18H18.5Z"
                fill={color}
            />
            <path
                className={className}
                d="M16.25 15.75L15.1895 14.6895L13.25 16.629V10.5H11.75V16.629L9.8105 14.6895L8.75 15.75L12.5 19.5L16.25 15.75ZM21.5 3V1.5H17V9H18.5V6H20.75V4.5H18.5V3H21.5ZM13.25 9H10.25V1.5H13.25C13.8466 1.5006 14.4185 1.73784 14.8403 2.15967C15.2622 2.5815 15.4994 3.15345 15.5 3.75V6.75C15.4994 7.34655 15.2622 7.9185 14.8403 8.34033C14.4185 8.76216 13.8466 8.9994 13.25 9ZM11.75 7.5H13.25C13.4489 7.5 13.6397 7.42098 13.7803 7.28033C13.921 7.13968 14 6.94891 14 6.75V3.75C14 3.55109 13.921 3.36032 13.7803 3.21967C13.6397 3.07902 13.4489 3 13.25 3H11.75V7.5ZM7.25 1.5H3.5V9H5V6.75H7.25C7.64764 6.7494 8.02883 6.59118 8.31 6.31C8.59118 6.02883 8.7494 5.64764 8.75 5.25V3C8.75 2.60218 8.59196 2.22064 8.31066 1.93934C8.02936 1.65804 7.64782 1.5 7.25 1.5ZM5 5.25V3H7.25L7.25075 5.25H5Z"
                fill={color}
            />
        </svg>
    );
};